import img1 from "../img/profile-1.png"
import img2 from "../img/profile-5.png"
import post1 from "../img/post1.jpg"
import post2 from "../img/post2.jpg"
import post3 from "../img/post3.jpg"

const Data = [
    {
        title:'The Blog Post',
        image:post1,
        author:'John',
        authorImg:img2,
        shortDescription:' short description short decsription',
        longDescription:'long description long description long description',
    },
    {
        title:'Post',
        image:post2,
        author:'Doe',
        authorImg:img1,
        shortDescription:' short description short decsription',
        longDescription:'long description long description long description',
    }
]
export default Data